import React from 'react';
import { useStaticQuery, graphql } from 'gatsby'

import SectionHeading from '../SectionHeading/SectionHeading';
import SponsorCard from './SponsorCard';
import { slugify } from '../../util/util';

const Sponsors = () => {
  const sponsorsQuery = useStaticQuery(graphql`
    query {
      allBuilderModels {
        sponsors (
          options: {
            cachebust: true
          }
        ) {
          id
          content
        }
        sponsorshipLevels (
          options: {
            cachebust: true
          }
        ) {
          id
          name
        }
      }
    }
  `);

  const list = sponsorsQuery?.allBuilderModels?.sponsors;
  const levels = sponsorsQuery?.allBuilderModels?.sponsorshipLevels;

  if (!list?.length || !levels?.length) {
    return null;
  }

  const sponsorsMap = new Map();
  levels.forEach(({ name }) => {
    sponsorsMap.set(name, [])
  });

  list.forEach(({ id, content }) => {
    const { data } = content;
    if (!data.level) {
      return;
    }
    if (sponsorsMap.has(data.level)) {
      sponsorsMap.get(data.level).push({ id, ...data});
    }
  });

  const filteredLevels = levels.filter(({ name }) => !!sponsorsMap.get(name).length);

  return (
    <div className="rs-team style2 team-home6-style pt-20 pb-20 md-pt-15 md-pb-15">
      {filteredLevels.map(({ id, name }) => {
        const levelSponsors = sponsorsMap.get(name);
        const title = `${name} ${name === 'Media' ? 'Partner' : 'Sponsor'}${levelSponsors.length > 1 ? 's' : ''}`
        return (
          <div key={id}>
            <SectionHeading
              title={title}
              centerText={true}
            />
            <div className="row">
              {levelSponsors.map((s) => (
                <SponsorCard
                  key={s.id}
                  name={s.name}
                  logo={s.logo}
                  url={`/sponsors/${slugify(s.name)}`}
                />
              ))}
            </div>
          </div>
        )
      })}
    </div>
  );
};

export default Sponsors;
